import { useState } from "react";
import { toast } from "sonner";
import { Smartphone } from "lucide-react";
import axios, { API } from "@/lib/api";
import { useLang, formatRs } from "@/lib/i18n";

const fieldCls = "w-full bg-transparent border-b border-white/20 py-3 outline-none focus:border-[#D4AF37] transition-colors duration-300";

export default function JuicePayment({ booking, onDone }) {
  const { t } = useLang();
  const [reference, setReference] = useState("");
  const [payer, setPayer] = useState(booking.name);
  const [busy, setBusy] = useState(false);
  const ref = `JR-${booking.token.slice(0, 6).toUpperCase()}`;
  const num = booking.payment?.juice_number;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await axios.post(`${API}/bookings/track/${booking.token}/payment`, { reference, payer_name: payer });
      onDone();
    } catch { toast.error(t.f_error); } finally { setBusy(false); }
  };

  return (
    <div className="gold-frame p-6 sm:p-10 mt-10" data-testid="juice-payment">
      <h2 className="font-display text-3xl mb-6 flex items-center gap-3"><Smartphone className="w-6 h-6 text-[#D4AF37]" />{t.pay_title}</h2>
      <ol className="space-y-2 text-slate-300 text-sm mb-8 list-decimal list-inside">{t.pay_steps.map((s) => <li key={s}>{s}</li>)}</ol>
      <dl className="grid sm:grid-cols-3 gap-6 mb-8 border-y border-white/10 py-6">
        <div><dt className="text-xs uppercase tracking-[0.2em] text-slate-500">{t.pay_number}</dt>
          <dd className="text-xl text-[#D4AF37] mt-1" data-testid="juice-number">{num || "—"}</dd></div>
        <div><dt className="text-xs uppercase tracking-[0.2em] text-slate-500">{t.pay_holder}</dt>
          <dd className="text-lg mt-1">{booking.payment?.juice_name}</dd></div>
        <div><dt className="text-xs uppercase tracking-[0.2em] text-slate-500">{t.pay_ref_label}</dt>
          <dd className="text-lg mt-1 font-mono" data-testid="juice-reference">{ref}</dd></div>
      </dl>
      {!num && <p className="text-sm text-amber-300 mb-6">{t.pay_pending_num}</p>}
      <p className="mb-6 text-lg">{t.tr_deposit} : <strong className="text-[#D4AF37]" data-testid="deposit-amount-pay">{formatRs(booking.deposit_amount)}</strong></p>
      <form onSubmit={submit} className="grid sm:grid-cols-2 gap-6">
        <label><span className="text-xs uppercase tracking-[0.2em] text-slate-400">{t.pay_tx}</span>
          <input required minLength={3} value={reference} onChange={(e) => setReference(e.target.value)} className={fieldCls} data-testid="payment-reference-input" /></label>
        <label><span className="text-xs uppercase tracking-[0.2em] text-slate-400">{t.pay_payer}</span>
          <input value={payer} onChange={(e) => setPayer(e.target.value)} className={fieldCls} data-testid="payment-payer-input" /></label>
        <button type="submit" disabled={busy} data-testid="payment-submit-btn"
          className="sm:col-span-2 justify-self-start bg-[#D4AF37] text-[#050B14] px-8 py-4 font-medium tracking-wider hover:bg-[#e6c55a] disabled:opacity-60 transition-colors duration-300">
          {t.pay_submit}
        </button>
      </form>
    </div>
  );
}
